import React, { useEffect, useRef, useState } from "react";
import { Table, Button, Modal, Form } from "react-bootstrap";
import Layout from "../../components/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { MdModeEdit, MdDelete } from "react-icons/md";
import ToastFile from "../../utils/ToastFile";
import {
  deleteAddressByID,
  deleteRouteByID,
  getAllParcelAddressbyRoute,
  getAllRoutebyContractor,
  uploadBulk,
} from "../../api/RouteApi";
import DeleteModel from "../../components/DeleteModel";
import Loader from "../../components/Loader";
import {
  FaArrowAltCircleDown,
  FaArrowAltCircleUp,
  FaDownload,
  FaEye,
  FaFileUpload,
  FaUpload,
} from "react-icons/fa";
import * as XLSX from "xlsx";
import ButtonLoader from "../../components/ButtonLoader";
import { Controller, useForm } from "react-hook-form";
import ReactSelect from "react-select";

const EmployeePanelAddress = () => {
  const { state } = useLocation();
  const fetched = useRef(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(true);
  const [isButtonLoading, setIsButtonloading] = useState(false);
  const [route, setRoute] = useState(null);
  const [parcelAddress, setParcelAddress] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [addressOption, setAddressOption] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const rowRefs = useRef([]);
  const containerRef = useRef(null);
  const [rowNumber, setRowNumber] = useState("");

  useEffect(() => {
    if (state?.route) {
      setRoute(state?.route);
    }
    if (fetched.current) return;
    fetched.current = true;
    getPanelAddress(state?.route);
  }, []);

  const getPanelAddress = (route) => {
    setIsloading(true);
    getAllParcelAddressbyRoute(route.route_id, true)
      .then((res) => {
        if (res.status === 200) {
          setParcelAddress(res?.data?.data?.addresses);
          setSortedData(res?.data?.data?.addresses);
          const options = res?.data?.data?.addresses.map((parcel) => ({
            value: parcel._id,
            label: parcel.address,
          }));
          setAddressOption(options);
        } else {
          ToastFile("Failed to fetch address", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching address:", err);
        ToastFile("Error fetching address", "error");
      })
      .finally(() => {
        setIsloading(false);
      });
  };

  const handleUploadToServer = async () => {
    setIsButtonloading(true);
    let payloadData = sortedData.map((item) => ({
      address: item.address,
      streetName: item.streetName,
      landmark: item.landmark,
    }));
    let payload = {
      data: payloadData,
      route_id: route?.route_id,
      tenant_id: user?.tenant_id,
      createdBy: user?.user_id,
      createdAt: new Date(),
      modifiedBy: user?.user_id,
      modifiedAt: new Date(),
      operation: "replace",
      isDuplicate: true,
    };
    await uploadBulk(payload)
      .then((res) => {
        if (res.status === 200) {
          ToastFile("File Save successfully", "success");
        } else {
          ToastFile("Failed to save file", "error");
        }
      })
      .catch(() => {
        ToastFile("Failed to save file", "error");
      })
      .finally(() => {
        setIsButtonloading(false);
      });
  };

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = ({ firstnumber }) => {
    const thisnumber = sortedData.findIndex((el)=>el._id === selectedAddress.value)
    const newArr = [...sortedData];
    const fromIdx = thisnumber;
    const toIdx = firstnumber-1;

    if (
      fromIdx < 0 ||
      fromIdx > newArr.length ||
      toIdx < 0 ||
      toIdx > newArr.length
    ) {
      ToastFile("Enter valid number", "error");
      return;
    }

    const temp = newArr[fromIdx];
    if(thisnumber > toIdx){
      // Shift elements downwards
      for (let i = fromIdx; i >= toIdx; i--) {
        newArr[i] = newArr[i - 1];
      }
    } else if(thisnumber < toIdx){
      // Shift elements upwards
      for (let i = fromIdx; i < toIdx; i++) {
        newArr[i] = newArr[i + 1];
      }
    }

    newArr[toIdx] = temp;
    setSortedData(newArr);
    ToastFile("Swap successfully", "success");
  };

  const swapItems = (idx1, idx2) => {
    if (
      idx1 < 0 ||
      idx2 < 0 ||
      idx1 >= sortedData.length ||
      idx2 >= sortedData.length
    )
      return;

    const newArr = [...sortedData];
    [newArr[idx1], newArr[idx2]] = [newArr[idx2], newArr[idx1]];
    setSortedData(newArr);
  };

  const UpintoList = (idx) => swapItems(idx, idx - 1);
  const DownintoList = (idx) => swapItems(idx, idx + 1);

  const handleGoClick = () => {

    const index = parseInt(rowNumber, 10) - 1;
    if (!isNaN(index) && rowRefs.current[index]) {
      rowRefs.current[index].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  return (
    <Layout>
      <div className="sticky-header bg-white">
          <Button 
            variant="outline-secondary" 
            size="sm"
            onClick={() => navigate("/generateParcelAddress")}
          >
            ← Back
          </Button>
      <div className="d-flex justify-content-between align-items-start align-items-md-center mb-3 gap-3">
        <div className="d-flex align-items-center gap-2">
           <span
            style={{
              fontSize: "22px",
              fontWeight: 600,
              minWidth: "140px",
            }}
          >
            Panel Address ({route?.routeName})
          </span>
        </div>
        <div>
          <Button onClick={() => handleUploadToServer()} className="bg-success">
            {"Save"}
          </Button>
        </div>
      </div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="d-flex flex-wrap align-items-center gap-2 pb-2 text-wrap justify-content-center"
        style={{ maxWidth: "100%" }}
      >
        <label className="mb-0 text-primary" style={{ fontSize: "18px", minWidth:100 }}>
          <b>Swapping : </b>
        </label>
        {/* <label className="mb-0">Add</label> */}

        <Form.Group className="d-flex align-items-center gap-2 mb-0 flex-wrap">
          <Form.Label className="mb-0">Add</Form.Label>
          <div style={{ minWidth: 200, flex: 1 }}>
            <Controller
              control={control}
              name="searchAddress"
              rules={{ required: false }}
              render={({ field }) => (
                <ReactSelect
                  {...field}
                  placeholder="Address"
                  // isMulti
                  className="py-1 rounded-0"
                  options={addressOption}
                  onChange={(selected) => {
                    field.onChange(selected);
                    setSelectedAddress(selected);
                  }}
                />
              )}
            />
          </div>
        </Form.Group>
        <Form.Group className="d-flex align-items-center gap-1 mb-0 flex-wrap">
        <Form.Label className="mb-0"> Set At</Form.Label>
          <Form.Control
            type="text"
            {...register("firstnumber", { required: true })}
            className="form-control form-control-sm"
            style={{ width: "70px", height:"38px" }}
            placeholder="Number"
          />
        </Form.Group>

        <button type="submit" className="btn btn-sm btn-primary" style={{height:"38px"}}>
          Update
        </button>
      </form>
      {/* <div className="d-flex justify-content-end align-items-center mb-2">
        Scroll To
        <input
          type="number"
          min="1"
          max={sortedData.length}
          value={rowNumber}
          onChange={(e) => setRowNumber(e.target.value)}
          placeholder="Enter row number"
          className="form-control me-2"
          style={{ width: 80, marginLeft:10 }}
        />
        <button
          className="btn btn-primary btn-sm"
          onClick={handleGoClick}
          disabled={!rowNumber}
        >
          Go
        </button>
      </div> */}
      </div>
      {/* Table Section - Mobile Responsive */}
      <div className="table-responsive" ref={containerRef}>
        <Table striped bordered hover className="table-sm">
          <thead className="table-dark">
            <tr style={{ textAlign: "center" }}>
              <th className="text-nowrap">Sr. No</th>
              <th className="text-nowrap">Address</th>
              <th className="text-nowrap">Up</th>
              <th className="text-nowrap">Down</th>
              {/* <th className="text-nowrap">Street Name</th> */}
              {/* <th className="text-nowrap d-none d-lg-table-cell">Landmark</th>
              <th className="text-nowrap">Actions</th> */}
            </tr>
          </thead>
          {isLoading ? (
            <tbody>
              <tr>
                <td colSpan="4">
                  <Loader />
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {sortedData.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center">
                    No route found
                  </td>
                </tr>
              ) : (
                sortedData.map((c, idx) => (
                  <tr key={idx} style={{ height: 40 }} ref={el => (rowRefs.current[idx] = el)}>
                    <td className="fw-bold" style={{ textAlign: "center" }}>
                      {idx + 1}
                    </td>
                    <td className="text-nowrap">
                      <div className="fw-bold" style={{ textAlign: "center" }}>
                        {c.address}
                      </div>
                    </td>
                    <td
                      className="text-nowrap"
                      style={{ textAlign: "center", minWidth: 60 }}
                      onClick={() => UpintoList(idx)}
                    >
                      {<FaArrowAltCircleUp color={"#5cb85c"} />}
                    </td>
                    <td
                      className="text-nowrap"
                      style={{ textAlign: "center", minWidth: 60 }}
                      onClick={() => DownintoList(idx)}
                    >
                      {<FaArrowAltCircleDown color={"#ffcc00"} />}
                    </td>
                    {/* <td className="text-nowrap">{c.streetName}</td>
                    <td className="text-nowrap d-none d-lg-table-cell">
                      {c.landmark}
                    </td>
                    <td className="text-nowrap" style={{ textAlign: "center" }}>
                      <button
                        className="btn btn-sm btn-outline-danger border-0"
                        onClick={() => {
                          setDeleteIndex(idx);
                          setDeleteModal(true);
                        }}
                        title="Delete"
                      >
                        <MdDelete size={16} />
                      </button>
                    </td> */}
                  </tr>
                ))
              )}
            </tbody>
          )}
        </Table>
      </div>
    </Layout>
  );
};

export default EmployeePanelAddress;
